import React, { useCallback } from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Modal from 'core/elements/modal'
import { deleteDomain } from './actions'

export default function DeleteDomainModal({ rows: [domain], onClose }) {
  const { update: deleteFn, updating: deletingItems, error } = useUpdateAction(deleteDomain)

  const handleDelete = useCallback(async () => {
    const { success } = await deleteFn(domain)
    if (success) onClose(true)
  }, [domain, deleteFn, onClose])

  return (
    <Modal
      panel="dialog"
      title="Delete Domain"
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingItems}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingItems}>
            Confirm
          </Button>
        </>
      }
    >
      <>
        <Text variant="body2">
          This will permanently delete <strong>{domain?.name}</strong>
        </Text>
        {!!error && <ErrorMessage>{error.message}</ErrorMessage>}
      </>
    </Modal>
  )
}
